import { css } from "@linaria/core";
export const cssWrapper = "cssWrapper_c1ubwug2";
export const cssContent = "cssContent_cylanht";

require("./StyledPanPinch.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledPanPinch.tsx");